import { datadogLogs } from '@datadog/browser-logs'
import { ref } from 'vue'

type Level = 'debug' | 'info' | 'warn' | 'error'

export const queue = ref<
  {
    id: string
    message: string
    level: Level
    timestamp: number
  }[]
>([])

export function log(
  message: string,
  options: {
    level?: Level
    context?: Record<string, unknown>
    error?: unknown
  } = {}
) {
  const { level = options.level || 'info', context, error } = options
  console[level](message, { error, context })
  datadogLogs.logger.log(message, context, level, error instanceof Error ? error : undefined)

  return {
    /** @param customMessage Optional custom message, falls back to log's message */
    notifyUser: (customMessage?: string) => notifyUser(customMessage || message, level),
  }
}

export function notifyUser(message: string, level: Level = 'info') {
  queue.value.push({
    id: crypto.randomUUID(),
    message,
    level,
    timestamp: Date.now(),
  })
}

export function clear(id: string | undefined) {
  if (!id) return
  const index = queue.value.findIndex((item) => item.id === id)
  if (index > -1) {
    queue.value.splice(index, 1)
  }
}
